// src/utils/debugUtils.js

export const initializeDebugMode = () => {
  if (typeof window === 'undefined') return;

  const urlParams = new URLSearchParams(window.location.search);
  const debugParam = urlParams.get('debug');

  if (debugParam === 'true') {
    sessionStorage.setItem('app_debug_mode', 'true');
    console.log('🐞 Debug Mode ACTIVATED for session');
  } else if (debugParam === 'false') {
    sessionStorage.removeItem('app_debug_mode');
    console.log('🐞 Debug Mode DEACTIVATED');
  }
};

export const isDebugMode = () => {
  if (typeof window === 'undefined') return false;

  const sessionDebug = sessionStorage.getItem('app_debug_mode') === 'true';
  return sessionDebug;
};
